
<nav class="navbar navbar-expand-lg bg-primary sticky-top">
  <div class="container-fluid mt-1">
    <h1 class="d-flex align-items-center">
      <ng-container *ngIf="customBackButton; else defaultBack">
        <ng-container *ngTemplateOutlet="customBackButton"></ng-container>
      </ng-container>
      <ng-template #defaultBack>
        <a
          *ngIf="btnBack"
          class="btn-back mx-2"
          defaultHref="#"
          (click)="back()">
          <i class="pi pi-angle-left"></i>
        </a>
      </ng-template>
      {{ title }}
    </h1>
    <button
      *ngIf="btnConfig"
      class="btn btn-light d-lg-none"
      type="button"
      (click)="menuOpen = !menuOpen">
      <i class="fa fa-bars"></i>
    </button>
    <div
      *ngIf="btnConfig"
      class="collapse navbar-collapse"
      [class.show]="menuOpen">
      <div class="menu-items d-flex flex-column flex-lg-row ms-auto">
        <ng-content></ng-content>
        <a
          *ngIf="btnHome"
          class="btn btn-menu"
          routerLink="/home">
          <i class="pi pi-home"></i>
          <span class="btn-menu-text">Início</span>
        </a>
        <a
          *ngIf="acompanhamento"
          class="btn btn-menu"
          routerLink="/acompanhamento-especial">
          <i class="fa-solid fa-eye"></i>
          <span class="btn-menu-text">Acompanhamento</span>
        </a>
        <a
          class="btn btn-menu"
          routerLink="/gerir-carteira-pesquisa">
          <i class="pi pi-wallet"></i>
          <span class="btn-menu-text">Carteira</span>
        </a>
        <a
          class="btn btn-menu"
          routerLink="/historico-pesquisa">
          <i class="pi pi-history"></i>
          <span class="btn-menu-text">Histórico</span>
        </a>
        <button
          type="button"
          class="btn btn-menu text-info"
          aria-label="Acessibilidade"
          aria-haspopup="dialog"
          (click)="op.toggle($event)">
          <i class="fa-solid fa-universal-access" aria-hidden="true"></i>
          <span class="btn-menu-text">Acessibilidade</span>
        </button>
      </div>
    </div>
  </div>
</nav>
<p-popover
  #op
  styleClass="gord-overlaypanel"
  [dismissable]="true"
  [autoZIndex]="true"
  [baseZIndex]="99999"
  appendTo="body">
  <app-accessibility></app-accessibility>
</p-popover>
